// AlarmModal.tsx

import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslate } from "../../../hooks/LanguageProvider";
import { Bounce, toast } from "react-toastify";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface AlarmModalProps {
  show: boolean;
  onHide: () => void;
  status: string | null; 
  title?: string | null; 
  IdUser: string; 
  IdAlarm: number; 
  updateAlarmList: () => void;
}

const DeleteAlarmModal: React.FC<AlarmModalProps> = ({ show, onHide, status, title,IdUser, IdAlarm,updateAlarmList  }) => {
  
  const { translate } = useTranslate();


  const deleteAlarm = async (id_alarm: number, id_user: string) => {


    try {
      const res = await fetch(`${backendUrl}/api/alarm/delete/${id_alarm}/${id_user}`, {
        method: "DELETE",
        mode: "cors",
      });
      onHide();
      if (!res.ok) {
       
  
        console.error("Error deleting  Alarm");
        status=null;
        toast.warn("Can't deleting  Alarm", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        
        return;
      }

      if (res.ok) {
       
        console.error("Alarm deleted successfully");
        updateAlarmList();  
        toast.success("Alarm deleted successfully !", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });

        show=false;
        return;
      }


    } catch (error) {
      console.error("Error deleting Alarm", error);


      toast.warn("Can't deleting  Alarm", {
        position: "bottom-right",
        autoClose: 2500, 
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      
    } 
  };
 
  return ( 
    <Modal  show={show} onHide={onHide} centered>
      <Modal.Header closeButton> 
        <Modal.Title style={{ fontWeight: 'bold', color: 'grey' }}><i className="las la-las la-trash "></i>{ title || ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center"> 
        <p> {status || ""}</p>   
      </Modal.Body>  
      <Modal.Footer>
        <button  className="btn btn-outline-danger mt-2 mx-auto" onClick={onHide}> 
            {translate("Close")}
        </button>
        <button   className="btn btn-outline-success mt-2 mx-auto" onClick={() =>deleteAlarm(IdAlarm,IdUser)}> 
          {translate("Delete")} 
        </button>
      </Modal.Footer>
    </Modal>
  );
};







export default DeleteAlarmModal;
